export enum ProSkillManagerCandidateStatusType {
  NONE = "NONE",
  INVITED = "INVITED",
  READY = "READY",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
  NOT_SHOW = "NOT_SHOW"
}